<div
  *ngIf="(pendingKyc$ | async) && (targetedRoutesToShowPendingKycBanner | async).includes(currentRoute$ | async)"
  class="bg-[#caecff91] h-[90px] flex items-center justify-center px-5 lg:px-8 lg:min-w-max lg:relative">
  <span class="text-base relative md:text-center"
    >Your documents are under review. You will be able to transact soon.
    <img class="w-[50px] h-[50px] inline-block lg:absolute" src="assets/images/bee.png" />
  </span>
</div>
